/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, lazy, Suspense } from "react";

const RoutewareCalendar = lazy(() => import("./routeware-calendar"));

const RoutewareCalendarComponent = (props) => {

    const component = props?.component;

    return (
        <Fragment>
            <div>
                <Suspense fallback={<div>Loading...</div>}>
                    <RoutewareCalendar component={component} />
                </Suspense>
            </div>
        </Fragment>
    );
};

export { RoutewareCalendarComponent };

